import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-drivers-history',
	templateUrl: './drivers-history.component.html',
	styleUrls: ['./drivers-history.component.css'],
})
export class DriversHistoryComponent implements OnInit {
	id: string;

	constructor(private readonly route: ActivatedRoute) {}

	ngOnInit(): void {
		if (!this.route.snapshot.params['id']) {
			return;
		}
		this.id = this.route.snapshot.params['id'];
	}
}
